module.exports = __webpack_public_path__ + "static/img/bg4.1bab140.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/bg4.png
// module id = UEvt
// module chunks = 1